import Util from "../Util";
import Constant from "../Constant";
import BootstrapTable from "react-bootstrap-table-next";
import {Alert} from "react-bootstrap";
import {useHistory} from "react-router-dom";
import {useState} from "react";

const CopyButton = ({text}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = (e) => {
    e.stopPropagation();
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <button
      onClick={handleCopy}
      onDoubleClick={(e) => e.stopPropagation()}
      style={{
        padding: '6px 10px',
        fontSize: '14px',
        cursor: 'pointer',
        border: '1px solid #ccc',
        borderRadius: '3px',
        backgroundColor: copied ? '#d4edda' : '#f8f9fa',
        fontWeight: 'bold',
        minWidth: '36px',
        height: '36px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.2s ease',
      }}
      onMouseEnter={(e) => {
        e.target.style.backgroundColor = copied ? '#d4edda' : '#e2e6ea';
        e.target.style.transform = 'scale(1.05)';
      }}
      onMouseLeave={(e) => {
        e.target.style.backgroundColor = copied ? '#d4edda' : '#f8f9fa';
        e.target.style.transform = 'scale(1)';
      }}
      title="Copy Activation Key"
      aria-label={copied ? "Activation key copied" : "Copy activation key"}
    >
      {copied ? '✓' : '📋'}
    </button>
  );
};

const parseList = list => {
  return list.map(el => {
    return {
      ...el,
      customerName: el.customerName || "-",
      contactName: el.contactName || "-",
      hardwareIds: Array.isArray(el.hardwareIds) && el.hardwareIds.length > 0
        ? el.hardwareIds.join(", ")
        : "-"
    }
  })
}
const baseColumns = [
  {
    dataField: 'id',
    text: 'ID',
    sort: true,
    headerStyle: () => ({width: '5%'})
  },
  {
    dataField: 'lastActivatedAt',
    text: 'Activated',
    sort: true,
    formatter: Util.formatDate,
    headerStyle: () => ({width: '20%'})
  }, {
    dataField: 'customerName',
    text: 'Customer Name',
    sort: true,
    headerStyle: () => ({width: '10%'})
  },
  {
    dataField: 'licenceSchema',
    text: 'Lic. schema',
    sort: true,
    headerStyle: () => ({width: '10%'})
  }
  , {
    dataField: 'activationKey',
    text: 'Activation Key',
    sort: true
  },   {
    dataField: 'hardwareIds',
    text: 'Hardware IDs',
    sort: true,
    headerStyle: () => ({width: '20%'}),
    formatter: (cell) => {
      if (!cell || cell === "-") return "-";
      return cell.length > 60 ? cell.substring(0, 60) + "..." : cell;
    }
  }
]

const purchaseOrderIdColumn = {
  dataField: 'purchaseOrderId',
  text: 'P. O. ID',
  sort: true,
}

export default function LicenceTable({licences, showPurchaseOrderId}) {
  const history = useHistory();

  const activationKeyFormatter = (cell) => (
    <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
      <span>{cell}</span>
      <CopyButton text={cell} />
    </div>
  );

  const resultColumns = baseColumns.map(col => {
    if (col.dataField === 'activationKey') {
      return {
        ...col,
        formatter: activationKeyFormatter
      };
    }
    return col;
  });

  if (showPurchaseOrderId) {
    resultColumns.push(purchaseOrderIdColumn);
  }

  const rowEvents = {
    onDoubleClick: (e, row) => history.push(`${Constant.url.LICENCES}?id=${row.id}`)
  }
  return licences?.length ? <BootstrapTable
                              keyField='id'
                              data={parseList(licences)}
                              columns={resultColumns}
                              hover
                              striped
                              rowEvents={rowEvents}
                              rowClasses={(row) => row.disabled ? "table-danger" : ""}
                              rowStyle={{ cursor: 'pointer' }}
                            />
    : <Alert variant="info">
      <b>No Results.</b><br/>
    </Alert>
}
